// extracted by css-extract-rspack-plugin
export default {"alert":"oXLrfY17tLghFV7X"};